<template>
    <p>Redirecting....</p>
</template>

<script>
    import StorageManager from "../security/StorageManager";

    export default {
        name: "RedirectComponent",
        beforeMount() {
            /**  redirect user to default page based on user role. **/
            let isAuth = this.$auth.isAuthenticated();
            if (isAuth) {
                let requestUrl = StorageManager.getItem("requestUrl");
                if (requestUrl != null && requestUrl != undefined) {
                    StorageManager.removeItem("requestUrl");
                    this.$router.push({path: requestUrl});
                } else {
                    this.$router.push({path: "/home"});
                }
            } else {
                this.$router.push({path: "/home"});
            }
        },
    }
</script>

<style scoped>

</style>
